import { Typography, TypographyProps } from '@mui/material';

const PageTitle = (props: TypographyProps) => (
  <Typography
    variant="h5"
    {...props}
    sx={{ mt: 0, mb: 2, fontWeight: 500, ...props.sx }}
  />
);
const Title = (props: TypographyProps) => (
  <Typography variant="h6" {...props} sx={{ mt: 0, mb: 2, ...props.sx }} />
);

const Section = (props: TypographyProps) => (
  <Typography
    variant="body1"
    gutterBottom
    {...props}
    sx={{ fontWeight: 700, ...props.sx }}
  />
);

const Header = (props: TypographyProps) => (
  <Typography
    variant="body2"
    {...props}
    sx={{ fontWeight: 700, ...props.sx }}
  />
);

const Body = (props: TypographyProps) => (
  <Typography variant="body2" {...props} />
);

const Caption = (props: TypographyProps) => (
  <Typography variant="caption" {...props} />
);

export default {
  Body,
  Caption,
  Header,
  PageTitle,
  Section,
  Title,
};
